/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleQuestionEmpty: {
  name: 'circle-question-empty';
  data: string;
} = {
  name: 'circle-question-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1.834a6.167 6.167 0 1 0 0 12.333A6.167 6.167 0 0 0 8 1.834ZM.833 8.001a7.167 7.167 0 1 1 14.334 0A7.167 7.167 0 0 1 .833 8ZM8 5a1.5 1.5 0 0 0-1.5 1.5.5.5 0 1 1-1 0 2.5 2.5 0 1 1 3.118 2.423.221.221 0 0 0-.104.058.071.071 0 0 0-.014.02V9.5a.5.5 0 1 1-1 0V9c0-.574.457-.94.872-1.046A1.5 1.5 0 0 0 8 5Zm0 7a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
